// extracted by mini-css-extract-plugin
export default {"content":"ShutterSurfaces_content__JJxjW"};